var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopIcon24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "laptop-icon-24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7151",
    "data-name": "Rectangle 7151",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(1.443 1.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M0,0H21.113V21.113H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M17.594,19.2v-.88a1.751,1.751,0,0,0,1.751-1.759l.009-8.8A1.759,1.759,0,0,0,17.594,6H3.519A1.759,1.759,0,0,0,1.759,7.759v8.8a1.759,1.759,0,0,0,1.759,1.759v.88H0v1.759H21.113V19.2ZM3.519,7.759H17.594v8.8H3.519Z",
    transform: "translate(0 -3.361)",
    fill: "#adb5b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIcon24);
export default __webpack_public_path__ + "static/media/laptop-icon-24.d3fc30442977ab34933ac77eda7e6e23.svg";
export { ForwardRef as ReactComponent };